import { JSX } from 'react';
import { PotentialMatchStudent } from 'types';
import { Box, Text } from '@chakra-ui/react';

type Props = {
  address: PotentialMatchStudent['address'];
};

export function TooltipAddress({ address }: Props): JSX.Element {
  if (!address) return null;

  const { line1, line2, line3, line4, line5, type, postcode } = address;
  return (
    <Box px={3} py={3} fontSize="xs" lineHeight={0}>
      {type && <Text paddingBottom={1}>{`${type} address`}</Text>}
      <br />
      {line1 && <Text>{line1}</Text>}
      {line2 && <Text>{line2}</Text>}
      <Text>
        {line3 && `${line3},`} {postcode && `${postcode}`}
      </Text>

      {line4 && <Text>{line4}</Text>}
      {line5 && <Text paddingBottom={0}>{line5}</Text>}
    </Box>
  );
}
